export default "__VITE_ASSET__a0dfb69c__"